// The charity host's class profile expressed as DATA for the class-blind @givmo/crm package.

import type { CrmModuleVocab } from '@givmo/crm';

export const charityCrmVocab: CrmModuleVocab = {
  contactsTitle: 'Contacts',
  contactsSubtitle:
    'Everyone in your CRM: people who gave through Givmo, and the contacts you imported.',
  allTabLabel: 'All',
  feedTabLabel: 'Givmo',
  suppliedTabLabel: 'Imported',
  feedSourceLabel: 'Givmo',
  suppliedSourceLabel: 'Imported',
  feedDescription:
    'Supporters who gave through Givmo and chose to share their details with your organization.',
  feedRecordLabel: 'Donor',
  anonymousFeedRecordLabel: 'Anonymous supporter',
  recurringLabel: 'Recurring',
  amountTotalLabel: 'Total donated',
  activityCountLabel: 'Gifts',
  firstActivityLabel: 'First gift',
  lastActivityLabel: 'Last gift',
  consentUnavailableTitle: 'Donor information isn’t available yet',
  emptyFeedTitle: 'No donors have chosen to share yet',
  emptyFeedDescription:
    'When a supporter chooses to share their details with your organization, they’ll appear here.',
  suppliedSegregationNote:
    'Imported contacts are records your organization supplied. They are never matched or combined with Givmo donor accounts.',
  suppliedBadgeLabel: 'Imported',
  suppliedEmptyTitle: 'No imported contacts yet',
  suppliedEmptyDescription:
    'Add a contact your organization already has, or bring them across from another tool.',
  detailFallbackTitle: 'Donor',
  detailSubtitle:
    'This supporter’s giving history with your organization, plus your team’s own notes.',
  recurringDetailLabel: 'Active recurring gift',
  activityTitle: 'Activity',
  activityDescription: 'Gifts and your team’s notes, newest first.',
  emptyActivityTitle: 'Nothing here yet',
  emptyActivityDescription: 'Gifts and notes for this supporter will appear here.',
  notePlaceholder: 'What should your team remember about this supporter?',
  termsActionLabel: 'Review the Charity Terms',
};
